import React from 'react';
import { Helmet } from 'react-helmet';
import ProgressScroll from '../components/Common/ProgressScroll';
import Cursor from '../components/Common/cusor';
import LoadingScreen from '../components/Common/loader';
import ContactUs from '../components/dark/contact/ContactUs';
import Info from '../components/dark/contact/info';
import Footer from '../components/dark/home/footer';
import NavTop from '../components/dark/home/nav-top';
import Navbar from '../components/dark/home/navbar';
import Portfolio from '../components/dark/home/portfolio';
import Price from '../components/dark/home/price';
import Profile from '../components/dark/home/profile';
import Services from '../components/dark/home/services';
import Skills from '../components/dark/home/skills';
import Testimonials from '../components/dark/home/testimonials';
import Lines from '../components/Common/Lines';
function HomeDark() {
  return (
    <div>
      <Helmet>
        <title>Praveen Dubbaka l Front End Developer l UI/UX Designer</title>
        <link rel="icon" href="/assets/imgs/favicon.ico" />
        <link rel="shortcut icon" href="/assets/imgs/favicon.ico" />
        <script src="https://code.jquery.com/jquery-3.7.1.min.js"></script>
        <script src="https://ajax.googleapis.com/ajax/libs/jquery/3.7.1/jquery.min.js"></script>
        <script src="/assets/js/scripts.js"></script>
        <script src="/assets/js/plugins.js"></script>
        <script src="https://cdnjs.cloudflare.com/ajax/libs/wow/1.1.2/wow.min.js"></script>
        <link rel="stylesheet" type="text/css" href="/assets/css/plugins.css" />
        <link rel="stylesheet" type="text/css" href="/assets/css/style.css" />
      </Helmet>
      <Cursor />
      <ContactUs />
      <Lines />
      <LoadingScreen />
      <ProgressScroll />
      <div>
        <NavTop />
        <main className="container">
          <Profile />
          <Navbar />
          <section className="in-box">
            <Services />
            <Skills />
            <Portfolio />
            <Testimonials />
            <Price />
            <Info />
          </section>
        </main>
        <Footer />
      </div>
      <script src="https://code.jquery.com/jquery-3.7.1.min.js" strategy="beforeInteractive"></script>
      <script src="https://ajax.googleapis.com/ajax/libs/jquery/3.7.1/jquery.min.js"  strategy="beforeInteractive"></script>
      <script src="/assets/js/plugins.js" strategy="beforeInteractive" />
      <script src="/assets/js/scripts.js" strategy="beforeInteractive" />
      <script src="/assets/js/three.min.js" strategy="lazyOnload" />
    </div>
  );
}

export default HomeDark;
